import { render, staticRenderFns } from "./SidebarBrandLogo.vue?vue&type=template&id=1b4f50b3&scoped=true&"
import script from "./SidebarBrandLogo.vue?vue&type=script&lang=ts&"
export * from "./SidebarBrandLogo.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarBrandLogo.vue?vue&type=style&index=0&id=1b4f50b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f50b3",
  null
  
)

export default component.exports